import React from 'react';
import { InputField } from '@wk/components-react16/dist/input-field/input-field';
import { useValidatedField } from '../../formHooks';
import { ValidatedFieldAtoms } from '../../formAtoms';

interface TextInputFieldProps {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldAtoms: ValidatedFieldAtoms<any, any>;
  helperText?: string;
  label: string;
  placeholder?: string;
  required?: boolean;
}

export const TextInputField: React.FC<TextInputFieldProps> = ({
  disabled = false,
  fieldAtoms,
  helperText,
  label,
  placeholder,
  required = false,
}) => {
  const { error, handleBlur, handleChange, showError, value } =
    useValidatedField(fieldAtoms);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event.target.value);
  };
  const indicatorRequired = required ? 'required' : 'none';
  return (
    <div>
      <InputField label={label} size="small" indicator={indicatorRequired}>
        <input
          disabled={disabled}
          onBlur={handleBlur}
          onChange={handleInputChange}
          placeholder={placeholder}
          type="text"
          value={value || ''}
          required={required}
          aria-required={required}
        />
      </InputField>
      {showError && error && (
        <div
          style={{
            color: 'var(--color-error, #d32f2f)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
      {!showError && helperText && (
        <div
          style={{
            color: 'var(--color-text-secondary, #666)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {helperText}
        </div>
      )}
    </div>
  );
};
